import { ExternalCell, ExternalRow, tokens } from '@cast/design-system';

import { DetailsRowContainer, DetailWitTitle } from './DetailsRowContainer';
import { StartupFailureEvent } from '../../../types';

export const StartupFailureEventRow = (event: StartupFailureEvent) => {
  return (
    <DetailsRowContainer event={event}>
      <ExternalRow
        height={22}
        top={-12}
        sx={{ borderTopColor: 'transparent !important' }}
        width="auto"
      >
        <ExternalCell startColumn={0} sx={{ width: '100% !important' }}>
          <DetailWitTitle
            title="Message:"
            detail="Startup probe failed continuously. Increased CPU and Memory overhead to improve container startup reliability."
            titleVariant="light"
          />
        </ExternalCell>
      </ExternalRow>
      {event.details.containers.length && (
        <>
          <ExternalRow
            height={36}
            typography="L10B"
            color="grey.700"
            sx={{ borderTop: tokens.theme.border.structural.neutral }}
          >
            <ExternalCell>Container</ExternalCell>
            <ExternalCell startColumn={1}>Probe failures</ExternalCell>
          </ExternalRow>

          {event.details.containers.map(({ name, probeFailureIncrease }) => (
            <ExternalRow key={name} height={28}>
              <ExternalCell startColumn={0} cellProps={{ typography: 'P12R' }}>
                {name}
              </ExternalCell>
              <ExternalCell startColumn={1} cellProps={{ typography: 'P12R' }}>
                {probeFailureIncrease}
              </ExternalCell>
            </ExternalRow>
          ))}
        </>
      )}
    </DetailsRowContainer>
  );
};
